import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { SetUiConfig } from "./ConfigActions";
import * as types from "./ConfigActionTypes";
import { type ConfigState, initialConfigState } from "./ConfigState";

function setUiConfigReducer(configState: ConfigState, action: SetUiConfig): ConfigState {
	const { _type, ...config } = action.config;

	return {
		...configState,
		...config,
	};
}

export const ConfigReducer = createReducer<ConfigState>(initialConfigState, {
	...pairActionTypeToReducer(types.SET_UI_CONFIG, setUiConfigReducer),
});
